import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MainLayoutComponent} from './main-layout.component';
import {RouterModule} from '@angular/router';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';

import {HeaderComponent} from './header/header.component';
import {NavigationComponent} from './navigation/navigation.component';
import {NavMenuComponent} from './nav-menu/nav-menu.component';

import {TranslatePipe} from '@ngx-translate/core';
import {NotificationsDrawerModule} from '../../../modules/notifications-drawer/notifications-drawer.module';

import {ToastContainerDirective, ToastrModule} from 'ngx-toastr';

import {MyAccountSettingsComponent} from './header/my-account-settings/my-account-settings.component';

import {MatTooltipModule} from '@angular/material/tooltip';

import {MatExpansionModule} from '@angular/material/expansion';
import {MatDialogModule} from '@angular/material/dialog';

import {TooltipPanelWrapperComponent} from '../../dumb/tooltip-panel-wrapper/tooltip-panel-wrapper.component';

@NgModule({
  imports: [
    CommonModule,
    MatToolbarModule,
    MatInputModule,
    MatIconModule,
    TranslatePipe,
    RouterModule,
    MatSidenavModule,
    NotificationsDrawerModule,
    ToastrModule,
    ToastContainerDirective,
    MatTooltipModule,
    MatExpansionModule,
    MatDialogModule,
    TooltipPanelWrapperComponent,
    MainLayoutComponent,
    NavigationComponent,
    NavMenuComponent,
    HeaderComponent,
    MyAccountSettingsComponent,
  ],
  exports: [],
})
export class MainLayoutModule {}
